/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CouponDTO {
  acquisition?: boolean;
  blogger?: boolean;
  couponId?: number;
  couponType?: number;
  couponUsageTypeId?: number;
  dateCreated?: Date;
  dateExpired?: Date;
  dateUpdated?: Date;
  enabled?: boolean;
  freeShipping?: number;
  freebieCount?: number;
  freebieMessage?: string;
  glampartner?: boolean;
  glampoints?: number;
  influencerStatusTypeIdRestriction?: number;
  maxRedeems?: number;
  mgm?: boolean;
  name?: string;
  personInviter?: number;
  renewal?: boolean;
  subscriptionTypeIds?: Array<number>;
  upgrade?: boolean;
  value?: number;
}
